import { ParamHistorical } from '../../../../../shared/types/param';

export interface ComplianceTermsHistoricalProps {
    historical: ParamHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createdAt: 'Fecha de creación',
    name: 'Nombre',
    active: 'Activo',
    extra: 'Descripción',
};
